// src/pages/public/NotFound/NotFoundPage.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../../../components/seo/SEO.jsx'
import Button from '../../../components/common/Button.jsx'

export default function NotFoundPage() {
    return (
        <>
            <SEO
                title="Page Not Found"
                description="The page you're looking for doesn't exist or has been moved."
                noindex={true}
            />

            <div className="min-h-screen bg-white flex flex-col justify-center">
                <div className="container-custom">
                    <div className="max-w-2xl mx-auto text-center">
                        {/* Illustration */}
                        <div className="mb-8">
                            <div className="w-64 h-64 mx-auto bg-gradient-to-br from-primary-100 to-primary-200 rounded-full flex items-center justify-center">
                                <div className="text-6xl">🔍</div>
                            </div>
                        </div>

                        {/* Content */}
                        <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-4">404</h1>
                        <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-6">
                            Page Not Found
                        </h2>
                        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
                            Sorry, we couldn't find the page you're looking for. The page might have been moved,
                            deleted, or you may have entered an incorrect URL.
                        </p>

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                            <Link to="/">
                                <Button variant="primary" size="large">
                                    Go Back Home
                                </Button>
                            </Link>
                            <Link to="/contact">
                                <Button variant="outline" size="large">
                                    Get Help
                                </Button>
                            </Link>
                        </div>

                        {/* Quick Links */}
                        <div className="border-t border-gray-200 pt-8">
                            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">
                                Popular Pages
                            </h3>
                            <div className="flex flex-wrap justify-center gap-6">
                                <Link to="/services" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                                    Services
                                </Link>
                                <Link to="/industries" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                                    Industries
                                </Link>
                                <Link to="/case-studies" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                                    Case Studies
                                </Link>
                                <Link to="/blogs" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                                    Blog
                                </Link>
                                <Link to="/careers" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                                    Careers
                                </Link>
                            </div>
                        </div>

                        {/* Search Suggestion */}
                        <div className="mt-8 p-4 bg-gray-50 rounded-lg">
                            <p className="text-sm text-gray-600 mb-3">
                                Can't find what you're looking for? Try searching:
                            </p>
                            <div className="max-w-md mx-auto">
                                <div className="flex">
                                    <input
                                        type="text"
                                        placeholder="Search our website..."
                                        className="flex-1 px-4 py-2 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
                                    />
                                    <button className="bg-primary-600 text-white px-4 py-2 rounded-r-lg hover:bg-primary-700 transition-colors text-sm font-medium">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}